<template>
  <section
    v-if="hasMapOrLink || (viewer?.is_owner && ownerViewMode)"
    class="w-full border-t border-slate-200 dark:border-slate-800"
    id="location"
    aria-label="Location"
  >
    <div v-if="hasMapOrLink" class="w-full h-[320px] sm:h-[400px] flex flex-col items-center justify-center bg-slate-200 dark:bg-slate-800 relative overflow-hidden">
      <div class="absolute inset-0 z-10 w-full">
        <PublicRestaurantMap
          :restaurant="restaurant"
          :show-owner-map-hint="viewer?.is_owner === true"
          container-class="h-[320px] sm:h-[400px] w-full overflow-hidden"
          link-class="min-h-[44px] text-white font-bold text-sm py-2 px-4 rounded-lg bg-[var(--rms-t5-primary,#2563eb)] hover:opacity-90 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--rms-t5-primary,#2563eb)] focus-visible:ring-offset-2"
        />
      </div>
    </div>
    <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-8 px-4">
      <div class="max-w-md mx-auto py-4 px-4 rounded border border-dashed border-slate-300/60 dark:border-slate-600/60 bg-slate-200/50 dark:bg-slate-700/20">
        <p class="text-sm font-mono text-slate-600 dark:text-slate-400">{{ $t('public.noMapSetOwnerMessage') }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PublicRestaurantMap from '@/components/public/PublicRestaurantMap.vue'
import { restaurantHasMapOrLink } from '@/utils/googleMapsUrl'

const props = defineProps({
  restaurant: { type: Object, default: () => ({}) },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})

const hasMapOrLink = computed(() => restaurantHasMapOrLink(props.restaurant))
</script>
